import { pngHomeValueIndexTrendsChartMakerV2 } from '../../summaryV2/utils/pngHomeValueIndexTrendsChartMaker.tsx';
import { pngSiteSizeToCostPerSFChartMaker } from '../../summaryV2/utils/pngSiteSizeToCostPerSFChartMaker.tsx';
import { pngSiteSizeToSiteValueChartMaker } from '../../summaryV2/utils/pngSiteSizeToSiteValueChartMaker.tsx';
import { Tkv2PDF, Tkv2PDFChartImages } from '../types.ts';

export const generateTkv2PDFChartImages = async (
  chartParams: Tkv2PDF['chartParams'],
): Promise<Tkv2PDFChartImages> => {
  const dateOfSaleChartImage = await pngHomeValueIndexTrendsChartMakerV2(chartParams.dateOfSale);
  const siteSizeVsSiteValueChartImage = await pngSiteSizeToSiteValueChartMaker(chartParams.site);
  const siteSizeVsCostChartImage = await pngSiteSizeToCostPerSFChartMaker(chartParams.site);

  return {
    dateOfSaleChartImage,
    siteSizeVsSiteValueChartImage,
    siteSizeVsCostChartImage,
  };
};
